
export const prepareEnumData = (e, localize, isOptionDisabled) => {
  const data = e.values.map(x => ({ id: x, name: localize(`enums.${e.name}_${x}`), disabled: isOptionDisabled && isOptionDisabled(x) } ))
  return data
}